import req from '../lib/req';

export function getTagListByIds(idList) {
  const params = {
    id: idList,
  };

  return req.get('/tag', {
    params: {
      where: JSON.stringify(params),
    },
  });
}
export function update(id, data) {
  return req.put(`/tag/${id}`, data);
}
